import "./YouthPrograms.scss";
import { programs,programsCardsGenerator } from "../../../Utils/utils";
import PageIntroduction from "../../../Utils/PageIntroduction";
const YouthPrograms = () => {
  //
  const programsData = programsCardsGenerator(programs)
  const sectionHeader = "Our Youth Empowerment Programs"

  const sectionContent = `We provide comprehensive support to young African farmers through
        training, resources, and community building initiatives that drive
        sustainable agricultural development.`

  return (
    <section className="youth-programs-section">
      <div>
        <PageIntroduction color="#111827" bg="#FFFFFF" title={sectionHeader} details={sectionContent}/>

        <div className="programs-grid">{programsData}</div>
      </div>
    </section>
  );
};

export default YouthPrograms;
